import { useForm } from "react-hook-form";
import { IoSave } from "react-icons/io5";
// import "./TypographySettings.css"; // Optional: for extra styling

const TypographySettings = () => {
  const { register, handleSubmit, watch } = useForm();

  const onSubmit = (data) => {
    console.log("Typography Settings Saved:", data);
  };

  const watchAll = watch();

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h3>Typography Settings</h3>
        <hr className="mb-4" />

        <div className="row g-3">
          {/* Font Color */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Font Color</label>
            <input
              type="color"
              className="form-control form-control-color border border-dark-subtle rounded"
              style={{ width: "100%", height: "40px", padding: "4px" }}
              {...register("color")}
              defaultValue="#000000"
            />
          </div>

          {/* Font Family */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Font Family</label>
            <select className="form-select" {...register("fontFamily")}>
              <option value="Arial">Arial</option>
              <option value="Roboto">Roboto</option>
              <option value="Open Sans">Open Sans</option>
              <option value="Lato">Lato</option>
              <option value="Montserrat">Montserrat</option>
            </select>
          </div>

          {/* Font Weight */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Font Weight</label>
            <select className="form-select" {...register("fontWeight")}>
              <option value="normal">Normal</option>
              <option value="bold">Bold</option>
              <option value="lighter">Lighter</option>
              <option value="bolder">Bolder</option>
              <option value="100">100</option>
              <option value="300">300</option>
              <option value="500">500</option>
              <option value="700">700</option>
              <option value="900">900</option>
            </select>
          </div>

          {/* Font Style */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Font Style</label>
            <select className="form-select" {...register("fontStyle")}>
              <option value="normal">Normal</option>
              <option value="italic">Italic</option>
              <option value="oblique">Oblique</option>
            </select>
          </div>

          {/* Font Size */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Font Size (px)</label>
            <input
              type="number"
              className="form-control"
              {...register("fontSize")}
              placeholder="e.g., 16"
            />
          </div>

          {/* Line Height */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Line Height</label>
            <input
              type="number"
              step="0.1"
              className="form-control"
              {...register("lineHeight")}
              placeholder="e.g., 1.5"
            />
          </div>

          {/* Letter Spacing */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">
              Letter Spacing (px)
            </label>
            <input
              type="number"
              step="0.1"
              className="form-control"
              {...register("letterSpacing")}
              placeholder="e.g., 1"
            />
          </div>

          {/* Text Transform */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Text Transform</label>
            <select className="form-select" {...register("textTransform")}>
              <option value="none">None</option>
              <option value="uppercase">Uppercase</option>
              <option value="lowercase">Lowercase</option>
              <option value="capitalize">Capitalize</option>
            </select>
          </div>

          {/* Text Align */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Text Align</label>
            <select className="form-select" {...register("textAlign")}>
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
              <option value="justify">Justify</option>
            </select>
          </div>

          {/* Text Decoration */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Text Decoration</label>
            <select className="form-select" {...register("textDecoration")}>
              <option value="none">None</option>
              <option value="underline">Underline</option>
              <option value="line-through">Line Through</option>
            </select>
          </div>
        </div>

        {/* Preview */}
        <div className="mt-4">
          <label className="form-label fw-bold">Live Preview</label>
          <div
            className="p-3 border rounded"
            style={{
              color: watchAll.color || "#000",
              fontFamily: watchAll.fontFamily,
              fontWeight: watchAll.fontWeight,
              fontStyle: watchAll.fontStyle,
              fontSize: watchAll.fontSize
                ? `${watchAll.fontSize}px`
                : undefined,
              lineHeight: watchAll.lineHeight,
              letterSpacing: watchAll.letterSpacing
                ? `${watchAll.letterSpacing}px`
                : undefined,
              textTransform: watchAll.textTransform,
              textAlign: watchAll.textAlign,
              textDecoration: watchAll.textDecoration,
            }}
          >
            My business is my control.
          </div>
        </div>

        {/* Submit */}
        <div className="d-flex justify-content-end mt-4">
          <button
            type="submit"
            className="btn btn-dark d-flex align-items-center gap-2"
          >
            <IoSave size={16} />
            Save Settings
          </button>
        </div>
      </form>
    </div>
  );
};

export default TypographySettings;
